import React, { useState, useEffect } from 'react';

import './index.scss';

interface IBixToggleProps {
  checked?: boolean;
  disabled?: boolean;
  id: string;
  text?: string;
  title?: string;
  onChange: (checked: boolean) => void;
}

const BixToggle: React.FC<IBixToggleProps> = props => {
  const { checked, disabled, onChange, text, title } = props;
  const [inputChecked, setInputChecked] = useState(false);

  useEffect(() => {
    if ((checked || false) !== inputChecked) {
      setInputChecked(checked || false);
    }
  }, [checked, inputChecked]);

  const handleOnChange = () => {
    const newCheckedState = !inputChecked;
    setInputChecked(newCheckedState);
    onChange(newCheckedState);
  };

  return (
    <div className="bix_toggle">
      <div className="toggle_wrap">
        <input
          type="checkbox"
          id={props.id}
          name={props.id}
          onChange={handleOnChange}
          checked={inputChecked}
          disabled={disabled}
        />
        <label htmlFor={props.id} title={title ?? undefined}>
          <span></span>
          <div className="text_label">{text}</div>
        </label>
      </div>
    </div>
  );
};

export default BixToggle;
